/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, arrayOf, RestSettings, SlicedDataSource } from '@gh/core-data';
import { StlListItemDto, StlMapper } from './stl.dto';

@Injectable()
export class StlRestService extends AbstractRestService {

  constructor(settings: RestSettings) {
    super(settings);
  }

  findAllAsDataSource(filter: any): SlicedDataSource<StlListItemDto> {
    const req = {
      searchString: filter.searchString,
      startDate: filter.startDate,
      endDate: filter.endDate,
    };

    return this.createSlicedDataSourceGet(`${this.bp}/scheduled-tasks`, req, undefined, arrayOf(StlMapper));
  }
}
